module.exports = __webpack_public_path__ + "img/heart-eyes-emoji.542b71c4.png";